import moment from "moment";
import React, { useState } from "react";
import FilterToolbar from "../inputs/FilterToolbar";
import { Badge, Button, Modal, Pagination, Table } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES } from "../../config/apiConfig";
import { TbLockSearch } from "react-icons/tb";
import Drawer from "../Drawer";
import CompanyQueriesForm from "../forms/CompanyQueriesForm";
import { IoMdAdd, IoMdSearch } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar, FaRegEdit } from "react-icons/fa";
import CompanyEditForm from "../forms/CompanyEditForm";
import EmptyTable from "./EmptyTable";
import TableLoading from "../TableLoading";
import { Tooltip } from "react-tooltip";
import CompanyInvoiceForm from "../forms/CompanyInvoiceForm";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useApplication } from "../../contexts/ApplicationContext";

const AdminRepresentativesTable = () => {
  const { userPermission } = useApplication();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isDrawerPermissionQueries, setIsDrawerPermissionQueries] =
    useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isDrawerViewInvoice, setIsDrawerViewInvoice] = useState(false);
  const [isDrawerEditRepresentative, setIsDrawerEditRepresentative] =
    useState(false);
  const itemsPerPage = 20;

  const {
    isLoadingListRepresentatives,
    error: errorListRepresentatives,
    data: listRepresentatives,
  } = useQuery(["listRepresentatives", currentPage, nameParam], async () => {
    const { data } = await axios.get(
      `${ADMIN.GET_REPRESENTATIVES}?page=${currentPage}&search=${nameParam}&itemsPerPage=${itemsPerPage}`
    );

    setTotalPages(data.data.totalPages || 1);
    setTotalCount(data.data.totalCount || 0);

    return data.data.data;
  });

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories"], async () => {
    const { data } = await axios.get(
      `${CATEGORIES.GET_ALL}?page=${currentPage}`
    );

    return data.data.data;
  });

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleViewInvoice = (company) => {
    setSelectedCompany(company);
    setIsDrawerViewInvoice((prevState) => !prevState);
  };

  const handleEditRepresentative = (company) => {
    setSelectedCompany(company);
    setIsDrawerEditRepresentative((prevState) => !prevState);
  };

  const handleEditPermissionQueries = (company) => {
    setSelectedCompany(company);
    setIsDrawerPermissionQueries((prevState) => !prevState);
  };

  return (
    <>
      <div className="flex justify-end gap-2 mb-3 mt-2">
        {userPermission === "POWER_USER" && (
          <Link
            to="/admin/financial-representative"
            className="bg-blue-800 ml-auto md:ml-0 mb-5 md:mb-0 fixed md:relative bottom-4 md:bottom-0 right-6 md:right-0 z-10 md:z-0 rounded-full md:rounded-md shadow-md md:shadow-md h-14 md:h-auto w-14 md:w-auto flex md:block justify-center items-center px-4 py-2 text-white"
            variant="contained"
          >
            <IoMdAdd className="block md:hidden text-2xl" />

            <span className="hidden md:block">Gerenciar Representantes</span>
          </Link>
        )}

        <Link
          to="/admin/new-representative"
          className="bg-primary ml-auto md:ml-0 mb-5 md:mb-0 fixed md:relative bottom-4 md:bottom-0 right-6 md:right-0 z-10 md:z-0 rounded-full md:rounded-md shadow-md md:shadow-md h-14 md:h-auto w-14 md:w-auto flex md:block justify-center items-center px-4 py-2 text-white"
          variant="contained"
        >
          <IoMdAdd className="block md:hidden text-2xl" />

          <span className="hidden md:block">Adicionar Representante</span>
        </Link>
      </div>
      <form
        className="flex gap-1 mt-5 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
        onSubmit={handleSearchName}
      >
        <input
          type="text"
          placeholder="Busque por nome, telefone, e-mail ou documento do representante..."
          className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
        />
        <Button
          size="sm"
          className="flex items-center bg-secondary w-20"
          type="submit"
        >
          <IoMdSearch />
        </Button>
      </form>

      {listRepresentatives?.length > 0 || isLoadingListRepresentatives ? (
        <>
          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          <div className="overflow-x-auto shadow-sm rounded-xl bg-white mt-0 md:mt-5 border border-gray-200">
            <Table striped={false} className="text-xs xl:text-sm">
              <Table.Head className="bg-gray-200 uppercase text-gray-600 text-[11px] tracking-wide">
                <Table.HeadCell className="bg-gray-200">
                  Representante
                </Table.HeadCell>
                <Table.HeadCell className="bg-gray-200">
                  Representante Pai
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-200">
                  Cadastro
                </Table.HeadCell>
                {userPermission === "POWER_USER" && (
                  <>
                    {" "}
                    <Table.HeadCell className="text-center bg-gray-200">
                      URL
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-200">
                      Asaas
                    </Table.HeadCell>
                  </>
                )}

                <Table.HeadCell className="text-center bg-gray-200">
                  Ações
                </Table.HeadCell>
              </Table.Head>

              <Table.Body className="divide-y divide-gray-200">
                {!isLoadingListRepresentatives ? (
                  listRepresentatives?.length > 0 ? (
                    listRepresentatives.map((representative, index) => (
                      <Table.Row
                        key={index}
                        className={`bg-white hover:bg-gray-50 transition ${
                          index % 2 === 0 ? "bg-white" : "bg-gray-50"
                        }`}
                      >
                        <Table.Cell className="text-gray-700 py-1 font-medium">
                          <div>
                            {representative.typeCustomer === "CPF"
                              ? representative.name
                              : representative.socialReason}
                          </div>
                          <div className="text-[11px] text-gray-400">
                            {representative.typeCustomer}:{" "}
                            {representative.document} -{" "}
                            <span
                              className={`inline-block font-semibold ${
                                representative.status === 1
                                  ? "text-green-500"
                                  : representative.status === 0
                                  ? "text-red-500"
                                  : "text-red-500"
                              }`}
                            >
                              {representative.status === 1
                                ? "Ativo"
                                : representative.status === 0
                                ? "Bloqueado"
                                : "Inadimplente"}
                            </span>
                          </div>
                        </Table.Cell>
                        <Table.Cell className="text-gray-700 py-1 font-medium">
                          <div>
                            {representative?.ParentCompany?.typeCustomer ===
                            "CPF"
                              ? representative?.ParentCompany?.name
                              : representative?.ParentCompany?.socialReason}
                          </div>
                        </Table.Cell>

                        <Table.Cell className="text-center text-gray-700 py-1">
                          <div>
                            {moment(representative.createdAt).format(
                              "DD/MM/yyyy"
                            )}
                          </div>
                          <div className="text-[11px] text-gray-400 -mt-1">
                            {moment(representative.createdAt).fromNow()}
                          </div>
                        </Table.Cell>
                        {userPermission === "POWER_USER" && (
                          <>
                            <Table.Cell className="text-center text-gray-700 py-1">
                              {representative?.representative?.url || "-"}
                            </Table.Cell>
                            <Table.Cell className="text-center text-gray-700 py-1">
                              {representative?.representative?.token_asaas
                                ? "Sim"
                                : "Não"}
                            </Table.Cell>
                          </>
                        )}

                        <Table.Cell className="text-center py-1">
                          <div className="flex justify-center items-center gap-2">
                            {/* Botão: Visualizar */}
                            <button
                              data-tooltip-id="tooltip-view-representative"
                              data-tooltip-content="Visualizar detalhes do cliente"
                              onClick={() =>
                                navigate(
                                  `/admin/customers/${representative?.uuid}`
                                )
                              }
                              className="p-2.5 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-700 transition duration-200"
                            >
                              <MdOutlineRemoveRedEye size={18} />
                            </button>
                            <Tooltip
                              id="tooltip-view-representative"
                              place="top"
                              className="z-50"
                            />

                            {/* Botão: Permissões */}
                            <button
                              data-tooltip-id="tooltip-edit-permissions"
                              data-tooltip-content="Editar permissões de consulta"
                              onClick={() =>
                                handleEditPermissionQueries(representative)
                              }
                              className="p-2.5 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 transition duration-200"
                            >
                              <TbLockSearch size={18} />
                            </button>
                            <Tooltip
                              id="tooltip-edit-permissions"
                              place="top"
                              className="z-50"
                            />
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    ))
                  ) : (
                    <Table.Row>
                      <Table.Cell
                        colSpan={4}
                        className="text-center py-4 text-gray-400"
                      >
                        Nenhum representante encontrado.
                      </Table.Cell>
                    </Table.Row>
                  )
                ) : (
                  <TableLoading cols={4} />
                )}
              </Table.Body>
            </Table>
          </div>

          {totalCount > 0 && (
            <div className="mt-3 text-center text-sm text-gray-600">
              Exibindo {(currentPage - 1) * itemsPerPage + 1}–
              {Math.min(currentPage * itemsPerPage, totalCount)} de {totalCount}{" "}
              registros
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </>
      ) : (
        <EmptyTable icon="person_off">
          Nenhum representante cadastrado
        </EmptyTable>
      )}
      <Drawer
        title={`Visualizar faturamento`}
        onClose={setIsDrawerViewInvoice}
        isOpen={isDrawerViewInvoice}
        className={"w-full md:w-4/6 lg:w-3/6 xl:w-2/6"}
      >
        <CompanyInvoiceForm
          company={selectedCompany}
          onClose={setIsDrawerViewInvoice}
          isDrawerOpen={isDrawerViewInvoice}
        />
      </Drawer>
      <Modal
        show={isDrawerPermissionQueries}
        onClose={() => setIsDrawerPermissionQueries(false)}
        size="4xl"
      >
        <Modal.Header>Permissões</Modal.Header>
        <Modal.Body>
          <CompanyQueriesForm
            company={selectedCompany}
            categories={categories}
            onClose={() => setIsDrawerPermissionQueries(false)}
            fetchCompanies={() =>
              queryClient.invalidateQueries(["listCustomers", currentPage])
            }
          />
        </Modal.Body>
      </Modal>
      <Drawer
        title={`Editar representante`}
        onClose={setIsDrawerEditRepresentative}
        isOpen={isDrawerEditRepresentative}
        className={"w-full md:w-4/6 lg:w-3/6 xl:w-3/6"}
      >
        <CompanyEditForm
          company={selectedCompany}
          onClose={setIsDrawerEditRepresentative}
          fetchCompanies={() =>
            queryClient.invalidateQueries(["listRepresentatives", currentPage])
          }
        />
      </Drawer>
    </>
  );
};

export default AdminRepresentativesTable;
